// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"1d685b0c","267":"2b18a241","339":"efcfa9b4","415":"803598ff","453":"30342d86"}[chunkId] + ".chunk.js";
};